<template>
  <el-dialog
    title="Create Consignment"
    width="97vw"
    top="2vh"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="closable"
    @closed="$emit('destroy')"
  >
    <ConsignmentCreateForm
      v-loading="isProcessing"
    />

    <template #footer>
      <el-button
        :disabled="!closable"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-dropdown
        split-button
        type="primary"
        :disabled="!closable"
      >
        Create (Thermal)
        <el-dropdown-menu
          slot="dropdown"
        >
          <el-dropdown-item>
            Create (PDF)
          </el-dropdown-item>
          <el-dropdown-item>
            Create & Book Pickup
          </el-dropdown-item>
          <el-divider />
          <el-dropdown-item>
            Save as Quote
          </el-dropdown-item>
          <el-dropdown-item>
            Create Import Only
          </el-dropdown-item>
          <el-dropdown-item>
            Create Third Party Return
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </el-dialog>
</template>

<script>
import ConsignmentCreateForm from '@/components/Application/Freight/Consignments/Form/Form'

export default {
  components: {
    ConsignmentCreateForm
  },
  data () {
    return {
      isVisible: true,
      isProcessing: false
    }
  },
  computed: {
    closable () {
      return !this.isProcessing
    }
  }
}
</script>
